import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';

const BACKGROUND_TIMEOUT_MS = 15000; // 15 seconds

export const useMobileAppState = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const backgroundTimestampRef = useRef<number | null>(null);

  useEffect(() => {
    // Only run on native mobile platforms
    if (!Capacitor.isNativePlatform()) return;

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        // App going to background - store timestamp
        backgroundTimestampRef.current = Date.now();
      } else if (document.visibilityState === 'visible') {
        // App coming back to foreground
        if (backgroundTimestampRef.current) {
          const timeAway = Date.now() - backgroundTimestampRef.current;
          
          if (timeAway > BACKGROUND_TIMEOUT_MS) {
            // More than 15 seconds away - redirect to app home (not landing page)
            if (location.pathname !== '/app') {
              navigate('/app', { replace: true });
            }
          }
          
          backgroundTimestampRef.current = null;
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [navigate, location.pathname]);
};
